import { ErrorHandler } from './http-error-handler';
import { Inject, Service } from './di-provider';
import http, { type NajizHttpProxy, type NajizHttpResponse } from '@moj/najiz-http';
import LoaderService from './loaderService';

@Service
export default class HttpService {
  @Inject(LoaderService) loaderService!: LoaderService;
  public httpInstance: NajizHttpProxy;
  public httpInstanceWithoutLoader: any;
  public httpInstanceWithOnlyDomainBaseUrl: any;

  constructor() {
    const config = {
      baseURL: import.meta.env.BASE_URL,
    };

    const showLoader = () => window.showLoader();
    const hideLoader = () => window.hideLoader();

    this.httpInstance = http.create(config);
    this.httpInstanceWithoutLoader = http.create(config);
    this.httpInstanceWithOnlyDomainBaseUrl = http.create({
      ...config,
      baseURL: location.origin,
    });

    this.httpInstance.interceptors.request.use(
      (request) => {
        if (request.data?.noGlobalLoader) {
          return request;
        }
        showLoader();
        return request;
      },
      (error: Error) => ErrorHandler.errorResponseHandler(error),
    );

    this.httpInstanceWithoutLoader.interceptors.request.use(
      (request: any) => request,
      (error: Error) => ErrorHandler.errorResponseHandler(error),
    );

    this.httpInstanceWithOnlyDomainBaseUrl.interceptors.request.use(
      (request: any) => request,
      (error: Error) => ErrorHandler.errorResponseHandler(error),
    );

    // Add a response interceptor
    this.httpInstance.interceptors.response.use(
      (response: NajizHttpResponse) => {
        hideLoader();
        return response;
      },
      (error: Error) => {
        ErrorHandler.errorResponseHandler(error);
      },
    );

    this.httpInstanceWithoutLoader.interceptors.response.use(
      (response: NajizHttpResponse) => response,
      (error: Error) => {
        ErrorHandler.errorResponseHandler(error);
      },
    );

    this.httpInstanceWithOnlyDomainBaseUrl.interceptors.response.use(
      (response: NajizHttpResponse) => response,
      (error: Error) => {
        ErrorHandler.errorResponseHandler(error);
      },
    );
  }
}
